var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
/*
 * 父component 里面子component 验证，把 provide-parent-form 放在嵌套component的dom 上面，
 * 在子component 里面不要需要form了， 如果需要访问父component的 ngFrom，通过构造函数注入 父component 的ngForm
 * 参考 https://medium.com/@john_oerter/angular-nested-forms-and-validation-844ea05d4063
 */
// @dynamic
var ProvideParentFormDirective = /** @class */ (function () {
    function ProvideParentFormDirective() {
    }
    ProvideParentFormDirective = __decorate([
        Directive({
            selector: '[provide-parent-forms]',
            providers: [
                {
                    provide: ControlContainer,
                    useFactory: function (form) {
                        return form;
                    },
                    deps: [NgForm]
                }
            ]
        })
    ], ProvideParentFormDirective);
    return ProvideParentFormDirective;
}());
export { ProvideParentFormDirective };
